module.exports = __webpack_public_path__ + "img/child.dfff5c14.jpg";